import {useRefState} from '@uigstudio/uig-nextjs-helper';

import {MapLayer, PlotFlags} from '~constants/plots';
import useMouseEvent from '~utils/map/events/useMouseEvent';
import useMapLoadedEffect from '~utils/map/events/useMapLoadedEffect';
import {MapRef} from '~types/Map';

export default function useHoverPlotEvent(mapRef: MapRef) {
    const [hovered, hoveredRef, setHovered] = useRefState<number | undefined>(
        undefined,
    );
    const onMouseEvent = useMouseEvent();

    useMapLoadedEffect(
        (map) => {
            map.on('mousemove', MapLayer.HexFill, (e) =>
                onMouseEvent(
                    map,
                    PlotFlags.Hovered,
                    hoveredRef,
                    setHovered,
                    e.features,
                ),
            );
            map.on('mouseleave', MapLayer.HexFill, () =>
                onMouseEvent(map, PlotFlags.Hovered, hoveredRef, setHovered),
            );
        },
        mapRef,
        {waitForSource: true},
    );

    return {hovered};
}
